var React = require('react');

function ProcessMobile (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.mt0{fill-rule:evenodd;clip-rule:evenodd;fill:#0066FF;}\r\n\t.mt1{fill:none;stroke:#0066FF;}\r\n\t.mt2{fill:none;stroke:#0066FF;stroke-width:2;}\r\n"),React.createElement("g",{"key":1},[React.createElement("circle",{"className":"mt0","cx":"299","cy":"10","r":"6","key":0}),React.createElement("path",{"className":"mt1","d":"M227,1286.5v-21c0-11-9-20-20-20H24c-11,0-20-9-20-20L1,945.4c0-11,9-20,20-20h258c11,0,20-5,20-16V618.1\r\n\t\tc0-11-9-20-20-20H21c-11,0-20-9-20-20V312.9c0-11,9-20,20-20h258c11,0,20-9,20-20V10","key":1}),React.createElement("path",{"className":"mt2","d":"M215,1273l12,12l12-12","key":2})])]);
}

ProcessMobile.defaultProps = {"version":"1.1","id":"Ebene_1","x":"0px","y":"0px","viewBox":"0 0 305 1467","style":{"enableBackground":"new 0 0 305 1467"},"xmlSpace":"preserve"};

module.exports = ProcessMobile;

ProcessMobile.default = ProcessMobile;
